@import "@/scss/use-bootstrap-mixins.scss";

.map {
  width: 100%;
  height: 100%;
  border-radius: 14px;
  border: 4px solid $primary;
}
